import { useMemo } from 'react'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface Props {
  isSelected?: boolean
  onClick?: () => void
  direction?: ArrowDirection
  className?: string
  isWrong?: boolean
}

export enum ArrowDirection {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}
const mediaQuery = [{ screen: '(min-width: 280px)', width: '45px' }]
const ArrowSelect = ({ isSelected, onClick, direction, className = '', isWrong }: Props): React.ReactElement => {
  const src = useMemo(() => {
    if (isWrong) return 'bootcamp/arrow-wrong.png'

    if (isSelected) return 'bootcamp/arrow-selected.png'

    return 'bootcamp/arrow-normal.png'
  }, [isSelected, isWrong])

  const directionClass = useMemo(() => {
    switch (direction) {
      case ArrowDirection.LEFT:
        return 'ml-auto rotate-[25deg]'

      case ArrowDirection.RIGHT:
        return 'rotate-[335deg]'

      default:
        return 'mx-auto'
    }
  }, [direction])

  return (
    <div className="w-16 sm:w-24">
      <ResponsiveImage
        imageClassName={`h-16 sm:h-24 cursor-pointer transform ${directionClass} ${className}`}
        imageWidths="50"
        mediaQuery={mediaQuery}
        onClick={onClick}
        srcKey={src}
      />
    </div>
  )
}

export default ArrowSelect
